<template>
  <div class="jjj">
    <div style="width:100%;">
      <div class="rain-date">
        <ul>
          <li
            :class="activeTime === 'time1' ? 'activeTime' : ''"
            @click="handleTimeSelect('time1')"
          >
            过去1小时
          </li>
          <li
            :class="activeTime === 'time3' ? 'activeTime' : ''"
            @click="handleTimeSelect('time3')"
          >
            过去3小时
          </li>
          <li
            :class="activeTime === 'time6' ? 'activeTime' : ''"
            @click="handleTimeSelect('time6')"
          >
            过去6小时
          </li>
          <li
            :class="activeTime === 'time12' ? 'activeTime' : ''"
            @click="handleTimeSelect('time12')"
          >
            过去12小时
          </li>
          <li
            :class="activeTime === 'time24' ? 'activeTime' : ''"
            @click="handleTimeSelect('time24')"
          >
            过去24小时
          </li>
        </ul>
      </div>
      <div class="actual-border">
        <div class="actual-content">
          <div class="actual-date">
            <img src="../imgs/jjj.png" />
            <span>{{ shijian }}</span>
          </div>
          <div class="actual-map">
            <div class="ditu"></div>
            <div class="star">
              <img src="../imgs/bjstar.png" alt />
            </div>
            <div class="c-d-case utils-case">
              <span>承德</span>
              <i>{{ cdr }}</i>
            </div>
            <p class="p1"><img src="../imgs/1.png" alt="" /></p>
            <div class="b-j-case utils-case">
              <span>北京</span>
              <i>{{ bjr }}</i>
            </div>
            <p class="p2"><img src="../imgs/1.png" alt="" /></p>
            <div class="z-j-k-case utils-case">
              <span>张家口</span>
              <i>{{ zjkr }}</i>
            </div>
            <p class="p3"><img src="../imgs/1.png" alt="" /></p>
            <div class="q-h-d-case utils-case">
              <span>秦皇岛</span>
              <i>{{ qhdr }}</i>
            </div>
            <p class="p4"><img src="../imgs/1.png" alt="" /></p>
            <div class="s-j-z-case utils-case">
              <span>石家庄</span>
              <i>{{ sjzr }}</i>
            </div>
            <p class="p5"><img src="../imgs/1.png" alt="" /></p>
            <div class="t-s-case utils-case">
              <span>唐山</span>
              <i>{{ tsr }}</i>
            </div>
            <p class="p6"><img src="../imgs/1.png" alt="" /></p>
            <div class="t-j-case utils-case">
              <span>天津</span>
              <i>{{ tjr }}</i>
            </div>
            <p class="p7"><img src="../imgs/1.png" alt="" /></p>
            <div class="l-f-case utils-case">
              <span>廊坊</span>
              <i>{{ lfr }}</i>
            </div>
            <p class="p8"><img src="../imgs/1.png" alt="" /></p>
            <div class="b-d-case utils-case">
              <span>保定</span>
              <i>{{ bdr }}</i>
            </div>
            <p class="p9"><img src="../imgs/1.png" alt="" /></p>
            <div class="c-z-case utils-case">
              <span>沧州</span>
              <i>{{ czr }}</i>
            </div>
            <p class="p10"><img src="../imgs/1.png" alt="" /></p>
            <div class="h-s-case utils-case">
              <span>衡水</span>
              <i>{{ hsr }}</i>
            </div>
            <p class="p11"><img src="../imgs/1.png" alt="" /></p>
            <div class="x-t-case utils-case">
              <span>邢台</span>
              <i>{{ xtr }}</i>
            </div>
            <p class="p12"><img src="../imgs/1.png" alt="" /></p>
            <div class="h-d-case utils-case">
              <span>邯郸</span>
              <i>{{ hdr }}</i>
            </div>
            <p class="p13"><img src="../imgs/1.png" alt="" /></p>
          </div>
          <!-- <div class="actual-unit"></div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
export default {
  name: "JJJrain",
  data() {
    return {
      activeTime: "time1",
      cdr: "",
      bjr: "",
      zjkr: "",
      qhdr: "",
      sjzr: "",
      tsr: "",
      tjr: "",
      lfr: "",
      bdr: "",
      czr: "",
      hsr: "",
      xtr: "",
      hdr: "",
      shijian: "",
    };
  },
  mounted() {
    this.require("time1");
  },
  methods: {
    handleTimeSelect(time) {
      this.activeTime = time;
      this.require(time);
    },
    require(time) {
      axios.get("/data/jjj/jjjRainData.json").then((res) => {
        if (time == "time1") {
          var times = res.data.hour_1.data[0].reqInfo.requestTime;
          this.shijian =
            moment(times, "YYYY-MM-DD HH:mm:ss")
              .add(-1, "hour")
              .format("MM/DD HH时") +
            "—" +
            moment(times, "YYYY-MM-DD HH:mm:ss").format("MM/DD HH时") +
            " " +
            "降水(mm)";
          var ss = res.data.hour_1.data[0].data;
        } else if (time == "time3") {
          var times = res.data.hour_3.data[0].reqInfo.requestTime;
          this.shijian =
            moment(times, "YYYY-MM-DD HH:mm:ss")
              .add(-3, "hour")
              .format("MM/DD HH时") +
            "—" +
            moment(times, "YYYY-MM-DD HH:mm:ss").format("MM/DD HH时") +
            " " +
            "降水(mm)";
          var ss = res.data.hour_3.data[0].data;
        } else if (time == "time6") {
          var times = res.data.hour_6.data[0].reqInfo.requestTime;
          this.shijian =
            moment(times, "YYYY-MM-DD HH:mm:ss")
              .add(-6, "hour")
              .format("MM/DD HH时") +
            "—" +
            moment(times, "YYYY-MM-DD HH:mm:ss").format("MM/DD HH时") +
            " " +
            "降水(mm)";
          var ss = res.data.hour_6.data[0].data;
        } else if (time == "time12") {
          var times = res.data.hour_12.data[0].reqInfo.requestTime;
          this.shijian =
            moment(times, "YYYY-MM-DD HH:mm:ss")
              .add(-12, "hour")
              .format("MM/DD HH时") +
            "—" +
            moment(times, "YYYY-MM-DD HH:mm:ss").format("MM/DD HH时") +
            " " +
            "降水(mm)";
          var ss = res.data.hour_12.data[0].data;
        } else if (time == "time24") {
          var times = res.data.hour_24.data[0].reqInfo.requestTime;
          this.shijian =
            moment(times, "YYYY-MM-DD HH:mm:ss")
              .add(-24, "hour")
              .format("MM/DD HH时") +
            "—" +
            moment(times, "YYYY-MM-DD HH:mm:ss").format("MM/DD HH时") +
            " " +
            "降水(mm)";
          var ss = res.data.hour_24.data[0].data;
        }
        var arr1 = [];
        var arr2 = [];
        var arr3 = [];
        var arr4 = [];
        var arr5 = [];
        var arr6 = [];
        var arr7 = [];
        var arr8 = [];
        var arr9 = [];
        var arr10 = [];
        var arr11 = [];
        var arr12 = [];
        var arr13 = [];
        for (var i = 0; i < ss.length; i++) {
          if (ss[i][1] == 54423) {
            arr1.push(Number(ss[i][2]));
          } else if (ss[i][1] == 54511) {
            arr2.push(Number(ss[i][2]));
          } else if (ss[i][1] == 54401) {
            arr3.push(Number(ss[i][2]));
          } else if (ss[i][1] == 54449) {
            arr4.push(Number(ss[i][2]));
          } else if (ss[i][1] == 53698) {
            arr5.push(Number(ss[i][2]));
          } else if (ss[i][1] == 54534) {
            arr6.push(Number(ss[i][2]));
          } else if (ss[i][1] == 54526) {
            arr7.push(Number(ss[i][2]));
          } else if (ss[i][1] == 54515) {
            arr8.push(Number(ss[i][2]));
          } else if (ss[i][1] == 661449) {
            arr9.push(Number(ss[i][2]));
          } else if (ss[i][1] == 54616) {
            arr10.push(Number(ss[i][2]));
          } else if (ss[i][1] == 54702) {
            arr11.push(Number(ss[i][2]));
          } else if (ss[i][1] == 53798) {
            arr12.push(Number(ss[i][2]));
          } else if (ss[i][1] == 53892) {
            arr13.push(Number(ss[i][2]));
          }
        }
        var s1 = 0;
        var s2 = 0;
        var s3 = 0;
        var s4 = 0;
        var s5 = 0;
        var s6 = 0;
        var s7 = 0;
        var s8 = 0;
        var s9 = 0;
        var s10 = 0;
        var s11 = 0;
        var s12 = 0;
        var s13 = 0;
        for (var i = 0; i < arr1.length; i++) {
          if (arr1[i] != "9999") {
            s1 += arr1[i];
          }
          if (arr2[i] != "9999") {
            s2 += arr2[i];
          }
          if (arr3[i] != "9999") {
            s3 += arr3[i];
          }
          if (arr4[i] != "9999") {
            s4 += arr4[i];
          }
          if (arr5[i] != "9999") {
            s5 += arr5[i];
          }
          if (arr6[i] != "9999") {
            s6 += arr6[i];
          }
          if (arr7[i] != "9999") {
            s7 += arr7[i];
          }
          if (arr8[i] != "9999") {
            s8 += arr8[i];
          }
          if (arr9[i] != "9999") {
            s9 += arr9[i];
          }
          if (arr10[i] != "9999") {
            s10 += arr10[i];
          }
          if (arr11[i] != "9999") {
            s11 += arr11[i];
          }
          if (arr12[i] != "9999") {
            s12 += arr12[i];
          }
          if (arr13[i] != "9999") {
            s13 += arr13[i];
          }
        }
        if (typeof s1 === "number" && window.isNaN(s1)) {
          this.cdr = "/";
        } else {
          this.cdr = s1.toFixed(1);
        }
        if (typeof s2 === "number" && window.isNaN(s2)) {
          this.bjr = "/";
        } else {
          this.bjr = s2.toFixed(1);
        }
        if (typeof s3 === "number" && window.isNaN(s3)) {
          this.zjkr = "/";
        } else {
          this.zjkr = s3.toFixed(1);
        }
        if (typeof s4 === "number" && window.isNaN(s4)) {
          this.qhdr = "/";
        } else {
          this.qhdr = s4.toFixed(1);
        }
        if (typeof s5 === "number" && window.isNaN(s5)) {
          this.sjzr = "/";
        } else {
          this.sjzr = s5.toFixed(1);
        }
        if (typeof s6 === "number" && window.isNaN(s6)) {
          this.tsr = "/";
        } else {
          this.tsr = s6.toFixed(1);
        }
        if (typeof s7 === "number" && window.isNaN(s7)) {
          this.tjr = "/";
        } else {
          this.tjr = s7.toFixed(1);
        }
        if (typeof s8 === "number" && window.isNaN(s8)) {
          this.lfr = "/";
        } else {
          this.lfr = s8.toFixed(1);
        }
        if (typeof s9 === "number" && window.isNaN(s9)) {
          this.bdr = "/";
        } else {
          this.bdr = s9.toFixed(1);
        }
        if (typeof s10 === "number" && window.isNaN(s10)) {
          this.czr = "/";
        } else {
          this.czr = s10.toFixed(1);
        }
        if (typeof s11 === "number" && window.isNaN(s11)) {
          this.hsr = "/";
        } else {
          this.hsr = s11.toFixed(1);
        }
        if (typeof s12 === "number" && window.isNaN(s12)) {
          this.xtr = "/";
        } else {
          this.xtr = s12.toFixed(1);
        }
        if (typeof s13 === "number" && window.isNaN(s13)) {
          this.hdr = "/";
        } else {
          this.hdr = s13.toFixed(1);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.jjj {
  flex: 16;
  margin-top: -2%;
  padding: 0 1% 12.5% 1%;
  box-sizing: border-box;
  display: flex;
  .rain-date {
    height: 4%;
    width: 100%;
    display: flex;
    ul {
      flex: 1;
      display: flex;
      li {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 20px;
        font-size: 25px;
        color: #3a3a3a;
      }
    }
    .activeTime {
      background-color: #3370cc;
      color: #ffffff;
    }
  }
  .actual-border {
    background-color: #fff;
    height: 95%;
    width: 100%;
    margin-top: 2%;
    box-shadow: 0 2px 2px 2px rgba(27, 27, 27, 0.1);
    .actual-content {
      width: 100%;
      height: 100%;
      padding: 2px;
      background: url("../imgs/weatherbj.jpg") no-repeat;
      background-size: 100% 100%;
      overflow: hidden;
      .actual-date {
        margin: 2% auto 0;
        width: 82%;
        height: 5.5%;
        align-items: center;
        display: flex;
        background: url("../imgs/actualdate.png") no-repeat;
        background-size: 100% 100%;
        img {
          height: 100%;
        }
        span {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 26px;
          font-weight: 700;
          height: 100%;
          width: 100%;
          color: #0f286e;
        }
      }
      .actual-map {
        position: relative;
        width: 100%;
        height: 79%;
        top: 1%;
        background: url("../imgs/jjjmap.png") no-repeat;
        background-size: 100% 100%;
        .ditu {
          position: absolute;
          z-index: 999;
          width: 100%;
          height: 100%;
          background: url("../imgs/京津冀地图线最上.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .actual-unit {
        margin: 6% auto 0;
        width: 35%;
        height: 6%;
        background: url("../imgs/logo.png") no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .actual-map {
    .star {
      position: absolute;
      display: flex;
      top: 36%;
      left: 46%;
      img {
        height: 18px;
        width: 18px;
      }
    }
    .utils-case {
      position: absolute;
      padding: 3px 10px 3px 10px;
      background-color: #80cfff;
      background-image: linear-gradient(0deg, #4cbcff 0%, #c9ebff 80%);
      border: 1px solid #80bdf1;
      box-shadow: 0px 2px 2px 1px #99979778;
      border-radius: 20px;
      display: flex;
      align-items: center;
      height: 40px;
      span {
        font-size: 20px;
        font-weight: 700;
        color: #00408e;
      }
      i {
        margin-left: 2px;
        font-size: 20px;
        font-weight: 700;
        color: #9b0000;
      }
    }
    .p1,
    .p2,
    .p3,
    .p4,
    .p5,
    .p6,
    .p7,
    .p8,
    .p9,
    .p10,
    .p11,
    .p12,
    .p13
     {
      img {
        width: 18px;
        height: 12px;
      }
    }
    .c-d-case {
      top: 12%;
      left: 54%;
    }
    .p1 {
      position: absolute;
      display: flex;
      top: 17%;
      left: 60%;
    }
    .b-j-case {
      top: 30%;
      left: 41%;
    }
    .p2 {
      position: absolute;
      display: flex;
      top: 35%;
      left: 46%;
    }
    .z-j-k-case {
      top: 20.4%;
      left: 18%;
    }
    .p3 {
      position: absolute;
      display: flex;
      top: 25.4%;
      left: 26%;
    }
    .q-h-d-case {
      top: 32%;
      right: 2%;
    }
    .p4 {
      position: absolute;
      display: flex;  
      top: 37%;
      left: 88%;
    }
    .s-j-z-case {
      top: 61%;
      left: 9%;
    }
    .p5 {
      position: absolute;
      display: flex;
      top: 66%;
      left: 17%;
    }
    .t-s-case {
      top: 38%;
      left: 68%;
    }
    .p6 {
      position: absolute;
      display: flex;
      top: 43%;
      left: 75%;
    }
    .t-j-case {
      top: 43%;
      left: 54%;
    }
    .p7 {
      position: absolute;
      display: flex;
      top: 48%;
      left: 61%;
    }
    .l-f-case {
      top: 47.5%;
      left: 41%;
    }
    .p8 {
      position: absolute;
      display: flex;
      top: 52.5%;
      left: 47%;
    }
    .b-d-case {
      top: 46.7%;
      left: 23%;
    }
    .p9 {
      position: absolute;
      display: flex;
      top: 51.5%;
      left: 29%;
    }
    .c-z-case {
      top: 61.5%;
      left: 48%;
    }
    .p10 {
      position: absolute;
      display: flex;
      top: 66%;
      left: 54%;
    }
    .h-s-case {
      top: 65.7%;
      left: 31%;
    }
    .p11 {
      position: absolute;
      display: flex;
      top: 70.5%;
      left: 38%;
    }
    .x-t-case {
      top: 74%;
      left: 15%;
    }
    .p12 {
      position: absolute;
      display: flex;
      top: 79%;
      left: 21%;
    }
    .h-d-case {
      top: 84%;
      left: 11%;
    }
    .p13 {
      position: absolute;
      display: flex;
      top: 88.7%;
      left: 17%;
    }
  }
}
</style>
